import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'eddydata-lib';
import { DespesaPrevistaLstComponent } from './despesa-prevista-lst/despesa-prevista-lst.component';

const routes: Routes = [
  {
    path: ':ano',
    component: DespesaPrevistaLstComponent, canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DespesaPrevistaRoutingModule { }

